import React from "react";
import svgUrl from "/opt/actions-runner/_work/v3-swap/v3-swap/src/assets/svg/share.svg?url";
const SvgShare = (props) => /* @__PURE__ */ React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: 2,
  stroke: "#fff",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4m14-7-5-5-5 5m5-5v12"
}));
export {SvgShare as ReactComponent};
export default svgUrl;
